import mutations from './customerList.mutations'
import actions from './customerList.actions'
import getters from './customerList.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
